/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'text/rub': {
    width: 44,
    height: 22,
    viewBox: '0 0 44 22',
    data: '<path pid="0" d="M17.754 12.017c0 2.196 1.188 3.582 3.402 3.582 2.214 0 3.402-1.387 3.402-3.582V4.709h1.494v7.326c0 2.988-1.638 4.895-4.896 4.896-3.258 0-4.896-1.926-4.896-4.878V4.709h1.494v7.308zm-7.621-7.308c2.196 0 3.762 1.404 3.762 3.618 0 2.16-1.477 3.348-3.115 3.492l3.24 4.896h-1.763l-3.06-4.77H6.802v4.77H5.309V4.709h4.824zm24.076 0c2.088 0 3.366 1.26 3.366 3.06 0 1.511-1.007 2.52-2.105 2.754 1.277.199 2.34 1.512 2.34 2.952 0 1.926-1.279 3.24-3.475 3.24h-5.472V4.709h5.346zm-3.852 10.674h3.672c1.404 0 2.233-.792 2.233-2.07 0-1.098-.757-2.07-2.233-2.07h-3.672v4.14zM6.803 10.63h3.15c1.421 0 2.394-.954 2.394-2.304 0-1.35-.973-2.286-2.395-2.286h-3.15v4.59zm23.554-.72h3.6c1.35 0 2.07-.828 2.07-1.926 0-1.08-.72-1.944-2.07-1.944h-3.6v3.87z" _fill="#0077C8"/>'
  }
})
